__webpack_require__.p = "https://cdn.mintmobile.com/wp-content/themes/mintmobile/build/v3/";